import { render, staticRenderFns } from "./productCenNav.vue?vue&type=template&id=6efdaf97&scoped=true"
import script from "./productCenNav.vue?vue&type=script&lang=js"
export * from "./productCenNav.vue?vue&type=script&lang=js"
import style1 from "./productCenNav.vue?vue&type=style&index=1&id=6efdaf97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efdaf97",
  null
  
)

export default component.exports